var map = {
	"./faceboook-feed-BG-naujas.jpg": 4033,
	"./faceboook-feed-BG.jpg": 5977,
	"./footer-BG.jpg": 2358,
	"./konferencijos-BG.jpg": 5479,
	"./musu-istorija-BG.jpg": 2745,
	"./naryste-BG.jpg": 4359,
	"./pradinis-page-BG.jpg": 2796,
	"./projektai-BG.jpg": 1452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8320;